"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbMessageModalNext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = require("lodash");

var _reactRedux = require("react-redux");

var _reactIntl = require("react-intl");

var _sbButton = require("../sb-button");

var _sbModal = require("../sb-modal");

var _actions = require("../../skybase-core/base/actions");

var _constants = require("./constants");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RIGHT = _constants.buttonPosition.RIGHT,
    LEFT = _constants.buttonPosition.LEFT,
    CENTER = _constants.buttonPosition.CENTER;
var i18n = (0, _reactIntl.defineMessages)({
  closeBtnLabel: {
    "id": "sb-message-modal-next.closeBtnLabel",
    "defaultMessage": "Close"
  }
});
/**
 * @typedef {Object} SbMessageModalNext.Button
 * @property {string} title
 * @property {function} onClick
 * @property {string} [position="right"]
 * @property {...*} rest The rest of properties is spread onto the underlying SbButton.
 */

var createButton = function createButton(_ref) {
  var title = _ref.title,
      position = _ref.position,
      onClick = _ref.onClick,
      rest = _objectWithoutProperties(_ref, ["title", "position", "onClick"]);

  return /*#__PURE__*/_react.default.createElement(_sbButton.SbButton, _extends({
    key: (0, _lodash.kebabCase)("".concat(title, "_").concat(position)),
    onClick: onClick
  }, rest), title);
};

var createButtons = function createButtons(buttons, position) {
  return buttons.filter(function (_ref2) {
    var btnPosition = _ref2.position;
    return btnPosition === position;
  }).map(createButton);
};
/**
 * This is the next generation replacement for SbMessageModal component.
 * It is agnostic of the way how modals are opened and closed. The onClick
 * property on buttons, and the onClickOverlay prop should be used to provide
 * mechanism for closing modals. If they are missing, the default close handler
 * uses the standard mechanism of dispatching a Redux action to close the
 * modal.
 * @param {Object} props
 * @param {string} props.title
 * @param {string} [props.message]
 * @param {Array<SbMessageModalNext.Button>} [props.buttons]
 * @param {string} [props.type]
 * @param {function} [props.onClickOverlay]
 * @param {string} [props.className]
 * @param {...*} rest @see SbModal
 * @returns {Node}
 */


var SbMessageModalNext = function SbMessageModalNext(_ref3) {
  var title = _ref3.title,
      message = _ref3.message,
      buttons = _ref3.buttons,
      _ref3$type = _ref3.type,
      type = _ref3$type === void 0 ? _constants.modalType.NOTICE : _ref3$type,
      onClickOverlay = _ref3.onClickOverlay,
      className = _ref3.className,
      rest = _objectWithoutProperties(_ref3, ["title", "message", "buttons", "type", "onClickOverlay", "className"]);

  var dispatch = (0, _reactRedux.useDispatch)();
  var defaultCloseHandler = (0, _react.useCallback)(function () {
    return dispatch((0, _actions.closeModal)());
  }, [dispatch]);

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var buttonsToRender = buttons !== null && buttons !== void 0 ? buttons : [{
    title: formatMessage(i18n.closeBtnLabel),
    position: RIGHT,
    onClick: defaultCloseHandler
  }];
  buttonsToRender = buttonsToRender.map(function (btn) {
    var _btn$position;

    btn.position = (_btn$position = btn.position) !== null && _btn$position !== void 0 ? _btn$position : RIGHT;
    return btn;
  });

  var Header = /*#__PURE__*/_react.default.createElement(_sbModal.SbModalHeader, {
    title: title,
    closeEnabled: false,
    id: "sb-message-modal-header"
  });

  var Footer = /*#__PURE__*/_react.default.createElement("div", {
    className: "sb-modal-footer fl-container fl-justify-end"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sb-modal-left"
  }, createButtons(buttonsToRender, LEFT)), /*#__PURE__*/_react.default.createElement("div", {
    className: "sb-modal-center"
  }, createButtons(buttonsToRender, CENTER)), /*#__PURE__*/_react.default.createElement("div", {
    className: "sb-modal-right"
  }, createButtons(buttonsToRender, RIGHT)));

  return /*#__PURE__*/_react.default.createElement(_sbModal.SbModal, _extends({
    Header: Header,
    Footer: Footer,
    onClickOverlay: onClickOverlay !== null && onClickOverlay !== void 0 ? onClickOverlay : defaultCloseHandler,
    className: (0, _classnames.default)('sb-message-modal', type, className)
  }, rest), /*#__PURE__*/_react.default.createElement("div", {
    className: "sb-message-modal-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sb-message-icon"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _utils.getIconClass)(type)
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "sb-message-text"
  }, message)));
};
/* eslint-disable react/require-default-props */


exports.SbMessageModalNext = SbMessageModalNext;
SbMessageModalNext.propTypes = {
  title: _propTypes.default.string,
  message: _propTypes.default.node.isRequired,
  buttons: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string.isRequired,
    onClick: _propTypes.default.func.isRequired,
    position: _propTypes.default.oneOf([LEFT, RIGHT, CENTER])
  })),
  type: _propTypes.default.string,
  onClickOverlay: _propTypes.default.func,
  className: _propTypes.default.string
};
/* eslint-enable react/require-default-props */
//# sourceMappingURL=sb-message-modal-next.js.map